import React from "react";
import { Copy, Check } from "lucide-react";
import { useState } from "react";
import toast from "react-hot-toast";

const Header = ({ rideId }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(rideId);
    setCopied(true);
    toast.success("Ride ID copied!");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-primary-600 text-white p-4">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs text-primary-100 uppercase tracking-wide">
            Ride ID
          </p>
          <p className="text-lg font-semibold select-all cursor-text">
            {rideId}
          </p>
        </div>
        <button
          onClick={handleCopy}
          className="bg-primary-700 hover:bg-primary-800 transition-colors rounded-lg p-2"
          title="Copy Ride ID"
        >
          {copied ? (
            <Check className="w-5 h-5 text-green-300" />
          ) : (
            <Copy className="w-5 h-5" />
          )}
        </button>
      </div>
    </div>
  );
};

export default Header;
